import React from 'react';
import { OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import WarningIcon from 'src/components/Icon/Warning';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { sectionProps } from 'src/tools/constant';
import {
  contentPages as cK,
  contentPagesToShow,
  tabs,
} from 'src/tools/contentModulesFieldName';
import css from './css.module.less';
const Option = OriSelect.Option;
// import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
// import { get } from 'lodash';
import { get } from 'lodash';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import ContentPageEditModal from 'src/components/Modules-revamp/ContentPageEditModal/ContentPage';
import ModalHoc from 'src/constrains/ModalHOC';
import { generateNewContentPage } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
import { checkResponsiveContentPageTab } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ContentTabEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    disabled,
    options,
    index,
    tabDraggableId,
    onSort,
    onDelete,
    contentOptions,
    modalOp,
    modalFunc,
    onModalConfirm,
    onAdd,
    breakpoint,
    scContentPages,
  } = props;
  const { inUsePages = [] } = contentOptions || {};
  const prefixName = [tabs, index];
  const { setShowModal, setModalTitle, setModalContent } = modalOp;

  return (
    <React.Fragment>
      <Section {...sectionProps} id={tabDraggableId}>
        <ItemWrapper title={getI18n('general.contentPageInARow')}>
          <Field name={[...prefixName, contentPagesToShow]}>
            <OriSelect disabled={disabled} size='large'>
              {options.map((i) => {
                const { label, value } = i;
                return (
                  <Option value={value} key={value}>
                    {label}
                  </Option>
                );
              })}
            </OriSelect>
          </Field>
        </ItemWrapper>
        <Field
          shouldUpdate={(p, c) => {
            return (
              get(p, [...prefixName, cK]) !== get(c, [...prefixName, cK]) ||
              get(p, [...prefixName, contentPagesToShow]) !==
                get(c, [...prefixName, contentPagesToShow])
            );
          }}>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const { checkEachTabPagesCountError } =
              checkResponsiveContentPageTab();
            const tab = getFieldValue(prefixName);
            const res = checkEachTabPagesCountError(tab, { breakpoint });
            const hasError = get(res, 'hasError');
            const errors = get(res, 'errors') || [];
            return hasError ? <ErrorDisplay2 err={errors} hasError /> : null;
          }}
        </Field>
      </Section>{' '}
      <Field name={[...prefixName, cK]}>
        {(p, m) => {
          const { value, onChange } = p;

          const handleItemOnSort = (obj) => {
            const { data } = obj;
            const { newIndex, oldIndex } = data || {};
            if (onSort) {
              onSort(value, onChange, oldIndex, newIndex);
            }
          };
          const handleOnItemDelete = (index) => {
            if (onDelete) {
              onDelete(value, onChange, index);
            }
          };

          const handleOnClickAdd = () => {
            if (onAdd) {
              //onAdd(value, onChange);
              showModal({
                data: generateNewContentPage(),
                index: value?.length || 0,
                isNew: true,
              });
            }
          };

          const handleOnAdd = (data) => {
            const { isNew } = data;
            if (isNew) {
              if (onAdd) {
                onAdd(value, onChange, data);
              }
            } else {
              if (onModalConfirm) {
                onModalConfirm(value, onChange, data, index);
              }
            }

            handleModalCancel();
          };
          const handleModalCancel = () => setShowModal(false);
          const showModal = (props: any) => {
            setShowModal(true);
            setModalTitle(
              getI18n('salesChannelContent.index.contentPageSetting'),
            );
            setModalContent(
              <ContentPageEditModal
                //validators={validators}
                contentPageList={contentOptions}
                modalRenderer={modalFunc}
                onCancel={handleModalCancel}
                onConfirm={handleOnAdd}
                scContentPages={scContentPages}
                {...props}
              />,
            );
          };

          const childGenerate = (data, index) => {
            const name = get(data, 'contentPage.name');
            const { checkEachContentPageError } =
              checkResponsiveContentPageTab();
            const res = checkEachContentPageError(data, {
              contentPages: inUsePages,
              breakpoint,
            });
            const hasError = get(res, 'hasError');
            return (
              <TextAndEditIcon
                additional={
                  hasError ? (
                    <div className={css.errorIconContainer}>
                      <WarningIcon />
                    </div>
                  ) : null
                }
                name={name}
                onClick={() => showModal({ data, index })}
              />
            );
          };

          return (
            <React.Fragment>
              <DragNDropColumns
                // disabled={!isPrimary}
                // hideAdd={!isPrimary}
                hideTitle
                childGenerate={childGenerate}
                data={value || []}
                droppableId={`salesChannelContentListContentPagesCarousel${tabDraggableId}`}
                onSort={handleItemOnSort}
                hideAdd={disabled}
                onAdd={handleOnClickAdd}
                addText={`+ ${getI18n('general.addContentPage')}`}
                onDelete={handleOnItemDelete}
              />
            </React.Fragment>
          );
        }}
      </Field>
    </React.Fragment>
  );
};
export default ModalHoc(ContentTabEdit, { width: 600 });
